import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "picker-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_date_picker, {
        modelValue: _ctx.inner,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inner) = $event)),
        "show-adjacent-months": "",
        color: "primary",
        min: _ctx.minDate,
        max: _ctx.maxDate,
        multiple: 'range'
      }, null, 8, ["modelValue", "min", "max"]),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Cancelar")
            ])),
            _: 1,
            __: [3]
          }),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('applyCustomRange')))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Aplicar")
            ])),
            _: 1,
            __: [4]
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}